/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DoublonsPersonneGridDto } from './DoublonsPersonneGridDto';
import {
    DoublonsPersonneGridDtoFromJSON,
    DoublonsPersonneGridDtoFromJSONTyped,
    DoublonsPersonneGridDtoToJSON,
} from './DoublonsPersonneGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DoublonsPersonneGridDtoPaginatedResults
 */
export interface DoublonsPersonneGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DoublonsPersonneGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DoublonsPersonneGridDto>}
     * @memberof DoublonsPersonneGridDtoPaginatedResults
     */
    results?: Array<DoublonsPersonneGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DoublonsPersonneGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DoublonsPersonneGridDtoPaginatedResults interface.
 */
export function instanceOfDoublonsPersonneGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DoublonsPersonneGridDtoPaginatedResultsFromJSON(json: any): DoublonsPersonneGridDtoPaginatedResults {
    return DoublonsPersonneGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DoublonsPersonneGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoublonsPersonneGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DoublonsPersonneGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DoublonsPersonneGridDtoPaginatedResultsToJSON(value?: DoublonsPersonneGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DoublonsPersonneGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

